import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Container, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';

export const FAQ = () => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Container maxWidth="md">
      <Box mt={4} mb={4}>
        <Accordion
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
          sx={{ boxShadow: 3, mb: 2 }}
        >
          <AccordionSummary
            id="panel1-header"
            aria-controls="panel1-content"
            expandIcon={expanded === 'panel1' ? <CloseIcon /> : <AddIcon />}
            sx={{ backgroundColor: '#f5f5f5' }}
          >
            <Typography variant="h6">How does scoring work?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body1" component="div">
              <strong>Points are achieved in two ways:</strong>
              <br /><br />
              <u><b>Pick the Score Games</b></u>
              <p>The goal is to have the closest score to the actual score while choosing the correct winner. If your prediction is closest, you get 1 point. Perfect score predictions get 3 points. In case of a tie, all tied players receive points. Your predicted score can't be a tie; it has to have a winner.</p>
              <br />
              <u><b>Pick the Winner Games</b></u>
              <p>Each week features several matchups where you will choose a winner. Correct picks earn .25 points per correct prediction.</p>
              <br />
              <u><b>Score + Winner Games</b></u>
              <p>Some Pick the Score games, usually Top 25 matchups, also count as Pick the Winner games. These games are marked with a Score + Winner tag on your picks. The team your score has winning is your winner pick, so if they win you earn the .25 points on top of any score points. A perfect score prediction on one of these games is worth 3.25 points.</p>
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
          sx={{ boxShadow: 3, mb: 2 }}
        >
          <AccordionSummary
            id="panel2-header"
            aria-controls="panel2-content"
            expandIcon={expanded === 'panel2' ? <CloseIcon /> : <AddIcon />}
            sx={{ backgroundColor: '#f5f5f5' }}
          >
            <Typography variant="h6">How are games selected?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body1" component="div">
              <p>Games involving the University of Utah and BYU will typically be chosen for "Pick the Score" games. When these teams are on bye, other high-profile matchups will be selected. Additionally, top 25 matchups and other close games will be included as "Pick the Winner" games.</p>
              <p>During Bowl Season, Conference Championships, and Playoffs, the organizers will select various games based on matchups.</p>
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
          sx={{ boxShadow: 3, mb: 2 }}
        >
          <AccordionSummary
            id="panel3-header"
            aria-controls="panel3-content"
            expandIcon={expanded === 'panel3' ? <CloseIcon /> : <AddIcon />}
            sx={{ backgroundColor: '#f5f5f5' }}
          >
            <Typography variant="h6">Can I suggest games?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body1">
              Sure! If there is a matchup you'd like included in the weekly slate, reach out to your group organizer to suggest it.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Container>
  );
};
